module.exports = __webpack_public_path__ + "6e573b1070391aafd1bb913a45e40e4a.png";